export const badenWuerttemberg = {
  slug: "baden-wuerttemberg",
  name: "Baden-Württemberg",
  hero: {
    eyebrow: "Bundesland-Übersicht",
    title: "Erdwärme in Baden-Württemberg",
    subtitle:
      "Kurze, praxisnahe Übersicht zu Förderung, Genehmigungen, Datenlage und typischen Standortthemen – als Einstieg vor Planung und Angeboten.",
    infoBox:
      "In Baden-Württemberg ist die Datengrundlage insgesamt stark, aber nicht in allen Teilräumen gleich vollständig. Anforderungen hängen außerdem vom Standort, Schutzgebieten und dem gewählten System ab.",
  },
  seo: {
    title:
      "Erdwärme in Baden-Württemberg – Förderung, Genehmigung & Daten | Erdwärme-Experten",
    description:
      "Kurzübersicht für Erdwärme in Baden-Württemberg: KfW-Förderung, wasserrechtliche Anforderungen, ISONG/Standortauskunft, Erdwärmesonden und typische Standortfaktoren.",
    canonical: "https://www.erdwaerme-experten.de/bundeslaender/baden-wuerttemberg",
  },

  facts: [
    {
      title: "Förderung (Bund)",
      icon: "BadgeCheck",
      color: "from-rose-600 to-rose-500",
      bullets: [
        "Heizungstausch-Zuschuss über KfW Programm 458 für Bestandsgebäude",
        "30 % Grundförderung; persönliche Boni können die Quote erhöhen",
        "Maximal 80 %; kein separater Effizienzbonus für Erdwärme",
      ],
      note:
        "Förderstand 21.07.2026. Die tatsächliche Förderfähigkeit hängt von Gebäude, Eigentum, Einkommen und weiteren Voraussetzungen ab.",
      link: {
        label: "KfW 458 (offiziell)",
        href: "https://www.kfw.de/inlandsfoerderung/Privatpersonen/Bestehende-Immobilie/F%C3%B6rderprodukte/Heizungsf%C3%B6rderung-f%C3%BCr-Privatpersonen-Wohngeb%C3%A4ude-%28458%29/",
      },
    },
    {
      title: "Genehmigung & Wasserrecht",
      icon: "ShieldCheck",
      color: "from-slate-700 to-slate-600",
      bullets: [
        "Bei Bohrungen ist eine Erlaubnis erforderlich, wenn in einen Grundwasserleiter eingedrungen oder dieser durchstoßen wird",
        "Besteht keine Erlaubnispflicht, sind Bohrungen über 10 m sowie grundwasserrelevante Arbeiten anzeigepflichtig",
        "Zuständig ist in der Regel die untere Wasserbehörde",
      ],
      note:
        "Die genaue Einordnung hängt vom konkreten Vorhaben und Standort ab; in Schutzgebieten können zusätzliche Einschränkungen gelten.",
      link: {
        label: "Baden-Württemberg: wasserrechtliche Hinweise",
        href: "https://um.baden-wuerttemberg.de/fileadmin/redaktion/m-um/intern/Dateien/Dokumente/2_Presse_und_Service/Publikationen/Umwelt/Muster-Verfahrenshandbuch-Wasser-barrierefrei.pdf",
      },
    },
    {
      title: "Datenlage & ISONG",
      icon: "Layers",
      color: "from-indigo-700 to-indigo-600",
      bullets: [
        "ISONG gibt standortbezogene Hinweise für Erdwärmesonden bis maximal 400 m Tiefe",
        "Für Erdwärmesonden ist ein prognostisches Bohrprofil verfügbar",
        "Das zugrunde liegende 3D-Modell ist für über 90 % der Landesfläche verfügbar",
      ],
      note:
        "Das macht Baden-Württemberg für eine datenbasierte Vorprüfung besonders interessant – auch wenn die Abdeckung nicht überall gleich vollständig ist.",
      link: {
        label: "ISONG Baden-Württemberg",
        href: "https://lgrbwissen.lgrb-bw.de/geothermie/oberflaechennahe-geothermie/erdwaermesonden/informationssystem-oberflaechennahe-geothermie-isong",
      },
    },
    {
      title: "Qualität & Ausführung",
      icon: "Drill",
      color: "from-emerald-700 to-emerald-600",
      bullets: [
        "Für Erdwärmesonden gelten in Baden-Württemberg die Leitlinien Qualitätssicherung Erdwärmesonden (LQS EWS)",
        "Die Wasserbehörde setzt diese Vorgaben in der konkreten Zulassungsentscheidung um",
        "Schutz des Grundwassers und schadensfreie Ausführung stehen im Mittelpunkt",
      ],
      note:
        "Baden-Württemberg ist bei Erdwärmesonden traditionell vergleichsweise streng und qualitätsorientiert aufgestellt.",
      link: {
        label: "LQS Erdwärmesonden",
        href: "https://um.baden-wuerttemberg.de/de/klima-energie/energiewende/erneuerbare-energien/geothermie/leitlinien-qualitaetssicherung-erdwaermesonden",
      },
    },
  ],

  dataCards: [
    {
      title: "Welche Daten sind relevant?",
      icon: "Layers",
      desc:
        "ISONG, Schutzgebiete, prognostisches Bohrprofil, erwartete Grundwasserverhältnisse und standortbezogene Effizienz der Erdwärmesondennutzung.",
    },
    {
      title: "Was ist häufig der Engpass?",
      icon: "ThermometerSun",
      desc:
        "Nicht nur die Technik, sondern häufig Wasserrecht, Schutzgebiete, Bohrtiefenbegrenzungen und die lokal tatsächlich zulässige Ausführung.",
    },
    {
      title: "Was macht euer GeoReport konkret?",
      icon: "FileText",
      desc:
        "Zusammenführung der verfügbaren Untergrunddaten mit erster Dimensionierung, Kosten- und Förderlogik – als Vorentscheidung vor Fachplanung und Angebotseinholung.",
    },
  ],

  faq: [
    {
      q: "Ist Erdwärme in Baden-Württemberg grundsätzlich gut machbar?",
      a: "Ja, grundsätzlich schon. Baden-Württemberg hat mit ISONG eine sehr hilfreiche Datengrundlage für die Vorprüfung. Gleichzeitig gibt es standortabhängige Einschränkungen, etwa durch Schutzgebiete, Grundwasser oder lokale geologische Risiken.",
      links: [
        {
          label: "ISONG – Erdwärmesonden",
          href: "https://lgrbwissen.lgrb-bw.de/geothermie/oberflaechennahe-geothermie/erdwaermesonden/informationssystem-oberflaechennahe-geothermie-isong",
        },
      ],
    },
    {
      q: "Brauche ich in Baden-Württemberg immer eine wasserrechtliche Erlaubnis?",
      a: "Nicht in jedem Fall in gleicher Form. Wenn Bohrungen in einen Grundwasserleiter eindringen oder diesen durchstoßen, ist eine Erlaubnis erforderlich. Daneben gibt es Anzeigepflichten, etwa bei Bohrungen über 10 m oder bei Arbeiten mit möglicher Auswirkung auf das Grundwasser.",
      links: [
        {
          label: "Verfahrenshandbuch Wasser",
          href: "https://um.baden-wuerttemberg.de/fileadmin/redaktion/m-um/intern/Dateien/Dokumente/2_Presse_und_Service/Publikationen/Umwelt/Muster-Verfahrenshandbuch-Wasser-barrierefrei.pdf",
        },
      ],
    },
    {
      q: "Warum ist Baden-Württemberg bei Erdwärmesonden so qualitätsorientiert?",
      a: "Für Erdwärmesonden gelten die Leitlinien Qualitätssicherung Erdwärmesonden (LQS EWS). Sie regeln Anforderungen an die Herstellung und sollen Schäden sowie Risiken für das Grundwasser vermeiden.",
      links: [
        {
          label: "LQS Erdwärmesonden",
          href: "https://um.baden-wuerttemberg.de/de/klima-energie/energiewende/erneuerbare-energien/geothermie/leitlinien-qualitaetssicherung-erdwaermesonden",
        },
      ],
    },
  ],

  cta: {
    title: "Baden-Württemberg-Standort prüfen (datenbasiert)",
    text:
      "Du bekommst eine standortbezogene Vorabschätzung: verfügbare Untergrunddaten, erste Dimensionierung, Kosten-/Förderlogik und Hinweise zu typischen Genehmigungsthemen – als Grundlage für die nächsten Schritte.",
    primary: {
      label: "Jetzt Standort-Report erstellen",
      href: "/report",
      title: "Erdwärme Standort-Report für Baden-Württemberg erstellen",
    },
    secondary: { label: "Erst Grundlagen ansehen", href: "/flache-geothermie" },
    footnote:
      "Tipp: Gerade in Baden-Württemberg lohnt sich eine frühe Vorprüfung, weil Datenlage und Wasserrecht oft viel über die Machbarkeit entscheiden.",
  },
};